/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientUserViewModel } from '../../models/client-user-view-model';

export interface GetClientUsers$Params {
      body?: {
'clientID'?: number;
'prefixText'?: string;
'count'?: number;
}
}

export function GetClientUsers(http: HttpClient, rootUrl: string, params?: GetClientUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientUserViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetClientUsers.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientUserViewModel>>;
    })
  );
}

GetClientUsers.PATH = '/api/Clients/GetClientUsers';
